import { render } from "./WorkspaceInstrumentButton.vue?vue&type=template&id=1425279a&scoped=true"
import script from "./WorkspaceInstrumentButton.vue?vue&type=script&lang=js"
export * from "./WorkspaceInstrumentButton.vue?vue&type=script&lang=js"

import "./WorkspaceInstrumentButton.vue?vue&type=style&index=0&id=1425279a&scoped=true&lang=scss"

import exportComponent from "D:\\tachyon\\Projects\\NowMedia\\tool_cases\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1425279a"]])

export default __exports__